import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26,
	height: 17,
	viewBox: "0 0 26 17",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 3,
		d: "m1.469 2.5 11.5 12.143L24.469 2.5"
	})
});
export default SvgKgArrowDown;
